import React, { useState, useEffect } from "react";
import "../../components/AddCity/AddCity.css";
import axios from "axios";

const AddCity = ({tokenStorage,openAddProfile,setOpenAddProfile,setFilterCityData }) => {
  const [countryDetailResponse, setCountryDetailResponse] = useState([]);
  // const [stateDetailResponse, setStateDetailResponse] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [allStates, setAllStates] = useState([]); // Store all states
  const [filteredStates, setFilteredStates] = useState([]);
  const baseAPI = process.env.REACT_APP_API_URL;

  function tokenStorageCountry(){
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETCountry?countryID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          setCountryDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  function tokenStorageState(){
    const storedToken = JSON.parse(localStorage.getItem("token"));
    //console.log(storedToken);

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETState?stateID=0&countryID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          //console.log(response.data.data);
          // setStateDetailResponse(response.data.data);
          setAllStates(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  };

  useEffect(() => {
    
    tokenStorageCountry();
    tokenStorageState();
  }, []);

  const [formData, setFormData] = useState({    
        id: 0,
        state_id: "",
        country_id: "",
        name: "",
  });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Include selected department in the formData
      const postData = {
        ...formData,       
      };

      // Make a POST request to your API endpoint with updated postData
      const response = await axios.post(
        `${baseAPI}adminpost/AddCity`,
        postData, // Send updated postData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
  

      // Optionally, reset the form
      setFormData({
       
        state_id: "",
        country_id: "",
        name: "",
      });
      
      // tokenStorageDepartment();
      tokenStorage();
      setOpenAddProfile (!openAddProfile); 
      setFilterCityData(false);
      // Clear the selected department value
      setSelectedValue("");
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  const handleCountryChange = (e) => {
    const selectedCountryId = e.target.value;
    setFormData((prev) => ({
      ...prev,
      country_id: selectedCountryId,
      state_id: "", // Reset the state when country changes
    }));

    // Filter states based on selected country
    const filtered = allStates.filter(
      (state) => state.country_id === parseInt(selectedCountryId, 10)
    );
    setFilteredStates(filtered);
  };

  const handleStateChange = (e) => {
    const state_id = e.target.value;
    setFormData((prev) => ({
      ...prev,
      state_id,
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleSelectChange = (event) => {
  //   // Handle the select input change and update the selected value
  //   formData.state_id = event.target.value;
  //   formData.country_id = event.target.value;
  //   //setSelectedValue(event.target.value);
    
  // };

  return (
    <div className="container-fluid">
      <br />

      <div className="cityDetail">
        <div className="city-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Country Name*</td>
              <td>State Name*</td>
              <td>city Name*</td>
            </tr>

            <tr>
              <td>
                <select 
                name="country_id"
                onChange={handleCountryChange}
                value={formData.country_id}
                className="dropdown-country">
                  <option className="dropdown-country" value="">
                    Select your option
                  </option>
                  {countryDetailResponse.map((item)=>(

                  <option key={item.id} value={item.id}>{item.name}</option>
                  ))}
                </select>
              </td>
              <td>
                <select name="state_id"
                className="dropdown-state"
                onChange={handleStateChange}
                value={formData.state_id}>
                  <option className="dropdown-state" value="">
                    Select your option
                  </option>
                  {filteredStates.map((item)=>(

                  <option key={item.state_id} value={item.state_id}>{item.stateName}</option>
                  ))}
                </select>
              </td>
              <td>
                <input type="text"
                  name="name"
                  placeholder="Enter Please" 
                  value={formData.name}
                  onChange={handleInputChange}
                  />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addCity-button">
            <button
              type="submit" onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Add city
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddCity;
